import { render, staticRenderFns } from "./MicroDataItem.vue?vue&type=template&id=78a538fd&scoped=true&"
import script from "./MicroDataItem.vue?vue&type=script&lang=js&"
export * from "./MicroDataItem.vue?vue&type=script&lang=js&"
import style0 from "./MicroDataItem.vue?vue&type=style&index=0&id=78a538fd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a538fd",
  null
  
)

export default component.exports